export default {
  // TODO: test return the same reference and not a copy.
  files: (state) => Object.values(state.list || {}),
  loading: (state) => state.loading,
  loadingBinnacle: (state) => state.loadingBinnacle,
  error: (state) => state.error,
  pagination: (state) => state.pagination,
  trays: (state) => Object.values(state.trays || {}),
  binnacleFile: (state) => state.binnacle,
  fileOnFlow: (state) => state.fileOnFlow || {},
  selectedFile: (state) => state.selectedFile,
  processType: (state) => state.processType,
  fileOnFlowAttachments: (state) => state.fileOnFlowAttachments,
  loadingNumeration: (state) => state.loadingNumeration,
  numerationFile: (state) => state.numerationFile,
  numerationFebosId: (state) => state.numerationFebosId,
  wizardData: (state) => state.wizardData,
  dashboardApprovals: (state) => state.dashboard.approvals,
  dashboardResume: (state) => state.dashboard.resume,
  dashboardApprovalsList: (state) => state.dashboard.approvalsList,
  dashboardApprovalsIndicators: (state) => state.dashboard.indicators,
  dashboardApprovalFlow: (state) => state.dashboard.flow,
  dashboardApprovalFlowLoading: (state) => state.dashboard.loading,
  referenceApprovals: (state) => state.referenceApprovals,
  approvalsTemplates: (state) => state.approvalsTemplates,
  templatePaginationData: (state) => state.templatePaginationData,
  purchaseTypes: (state) => state.purchaseTypes,
  categoryOptions: (state) => state.categoryOptions,
  documentOptions: (state) => state.documentOptions,
  purchaseTypeOptions: (state) => state.purchaseTypeOptions,
  reportTypeOptions: (state) => state.reportTypeOptions,
  consequenceOptions: (state) => state.consequenceOptions || [],
  stepTypes: (state) => state.stepTypes || [],
  stepTypesOptions: (state) => state.stepTypes || [],
  stepRoles: (state) => state.stepRoles || [],
  aprovalTemplate: (state) => state.aprovalTemplate,
  infoCU: (state) => state.infoCU,
  documentTypeReferences: (state) => state.documentTypeReferences
};
